<template>
  <component :is="tagName(tagSpec(tagSpecs, 0))"
             :class="tagClasses(tagSpec(dynamicTagSpecs, 0))"
             @click="toggle"
  >

    <slot></slot>

  </component>
</template>

<script>
export default {
  props: {
    tagSpecs: {
      type: String,
      default: 'button.btn'
    },

    locus: {
      type: String,
      required: true
    }
  },

  methods: {
    toggle: function (){
      this.status = !this.status;
    }
  },

  computed: {
    status: {
      get: function() {
        return this.$read(this.locus);
      },
      set: function (val){
        this.$write(this.locus, val);
      }
    },

    dynamicTagSpecs: function () {
      let status = (this.status) ? 'on' : 'off';

      return this.tagSpecs
          .concat(' ')
          .concat(status);

    }
  }
}
</script>

<style scoped>
  .on .off{
    display: none;
  }
  .off .on{
    display: none;
  }
</style>
